module.exports = __webpack_public_path__ + "img/ladder.13e46693.jpg";